<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "dashboard",
  components: {},
  computed: {
    ...mapGetters(["needsResetPassword"])
  },
  mounted() {
    if(this.needsResetPassword) {
      setTimeout(()=>{
        this.$router.push({ name: "users-change-password" });
      }, 2000);
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
      setTimeout(()=>{
        this.$router.push({ name: "atg" });
      }, 2000);
    }
  },
  methods: {}
};
</script>
